import { Component } from '@angular/core';

@Component({
    selector: 'server-error',
    templateUrl: './server-error.html',
    styleUrls: [ './fullscreen-message.scss' ],
})
export class ServerError {}
